import type { IFavoriteColorCircle } from './types';

export const FavoriteColorCircle: React.FC<IFavoriteColorCircle> = (props) => {
  const { backgroundColor, diameter = 12, style } = props;

  return (
    <div
      style={{
        backgroundColor,
        width: `${diameter}px`,
        height: `${diameter}px`,
        borderRadius: '50%',
        ...style,
      }}
    />
  );
};
